import { Component } from '@angular/core';

@Component({
    selector: 'app-ribbon-header',
    templateUrl: './ribbon-header.component.html',
    styleUrls: ['./ribbon-header.component.scss'],
    standalone: false
})
export class RibbonHeaderComponent {}
